import { MODULE_LINK_TYPE } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/new/ui/admin/update/${moduleId}/${seriesId}/edit`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/new/ui/admin/update/${moduleId}/${seriesId}/track`,
  [MODULE_LINK_TYPE.ANALYTICS]: (moduleId: string, seriesId: string, moduleName: string) =>
    `modules/${moduleId}/update/learners?gameType=update&inSeries=${seriesId}&name=${moduleName}`,
};

export const LEARNER = {};
